import {isMobile} from "../helpers";

export function appendTooltip($target, content) {

  let hoverTimeout = null;

  $target.on('mouseenter', function() {
    if (isMobile()) return;

    const $title = jQuery(this).find(".history-item-title")

    // Se il testo non è troncato, non mostrare tooltip
    if ($title.length > 0 && $title[0].scrollWidth <= $title[0].clientWidth) return;

    // Avvia il timer di 1 secondo
    hoverTimeout = setTimeout(function() {
      showTooltip($target);
    }, 1000);
  });


  // Gestione mouseleave (hover out)
  $target.on('mouseleave', function() {
    if (isMobile()) return;

    jQuery(this).find(".tooltip").remove()

    clearTimeout(hoverTimeout);
    hoverTimeout = null;
  });

  // Crea tooltip se non esiste
  function createTooltip() {
    return `
      <div class="absolute bottom-[-76px] left-0 z-10 inline-block px-3 py-2 text-sm bg-white rounded-md shadow-xs tooltip border border-gray-200">
        ${content}
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>
    `
  }

  // Mostra tooltip
  function showTooltip() {
    const tooltip = createTooltip()
    $target.append(tooltip);

    const rect = $target[0].getBoundingClientRect();

    const $tip = $target.siblings(".tooltip")

    // Posizionamento sotto l'elemento
    const left = rect.left + (rect.width / 2);
    const top = rect.bottom + 10;

    $tip.css({
      left: left + 'px',
      top: top + 'px',
      transform: 'translateX(-50%)'
    });

    // Mostra con animazione
    setTimeout(function() {
      $tip.addClass('show');
    }, 10);
  }

}
